import {makeAutoObservable, observable} from 'mobx';

import {Reaction} from '@/domain/models/Reaction';
import queryClient from '@/shared/lib/react-query/queryClient';

import {FEATURES_QUERY_SENT} from '../consts/queryKeys';

class SentStore {
  list = observable.array<Reaction>([], {deep: false});
  count = 0;
  fetchedAllReactions: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  private get reactionsIds() {
    return new Set(this.list.map((item) => item.id));
  }

  get lastLoadedReactionAt() {
    return this.list[this.list.length - 1]?.created_at;
  }

  get empty() {
    return this.list.length === 0 && this.fetchedAllReactions;
  }

  setFetchedAllReactions(fetched: boolean) {
    this.fetchedAllReactions = fetched;
  }

  addReactions(list: Reaction[]) {
    if (list.length === 0) {
      return;
    }

    const nextItems = list.filter((item) => !this.reactionsIds.has(item.id));

    if (nextItems.length > 0) {
      this.list.push(...nextItems);
    }
  }

  setCount(count: number) {
    this.count = count;
  }

  addOrReplaceReaction(reaction: Reaction) {
    const index = this.list.findIndex((item) => item.id === reaction.id);

    if (index >= 0) {
      this.list[index] = reaction;
      return;
    }

    this.list.unshift(reaction);
    this.count += 1;
  }

  removeByUser(userId: number) {
    const nextList = this.list.filter(
      (reaction) => reaction.user_id !== userId
    );
    const removedCount = this.list.length - nextList.length;

    if (removedCount === 0) {
      return;
    }

    this.list.replace(nextList);
    this.count = Math.max(0, this.count - removedCount);
  }

  resetList() {
    this.list.clear();
    this.fetchedAllReactions = false;
    queryClient.removeQueries({
      queryKey: [FEATURES_QUERY_SENT],
    });
  }
}

export const sentStore = new SentStore();
